import React from 'react';
import { connect } from 'react-redux';
import { StyleSheet, View } from 'react-native';
import {
  setAllDayChecked,
  setCurrentTime,
  setDuration,
  setDurationType,
  setDurationUnits,
  setPainType,
} from '../actions';
import Moment from 'moment';
import FloatingInput from '../../../design/components/FloatingInput';
import strings from '../strings';
import { Text, Toast } from '../../../design/components';
import SquareCheckButton from '../../../design/components/SquareCheckButton';
import { designConstants } from '../../../design/styles';

class TimingSectionContent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      durationType: this.props.durationType,
      duration: this.formatDuration(
        this.props.duration,
        this.props.durationUnits,
      ),
      durationUnits: this.props.lengthOfPainUnit || 'Minutes',
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    let duration = this.formatDuration(props.duration, props.durationUnits);
    if (parseFloat(this.state.duration) !== duration) {
      this.setState({ duration: '' }, () => {
        this.setState({ duration });
      });
    }
  }

  onStartDateChanged = (str, date) => {
    date = Moment(date).valueOf();
    this.props.dispatch(setCurrentTime(date));
  };

  onEndDateChanged = (str, date) => {
    let start =
      typeof this.props.recordTime !== 'undefined'
        ? Moment(this.props.recordTime)
        : Moment();
    let duration = Moment(date).diff(start, 'seconds');
    if (duration < 0) {
      Toast.show({
        supportedOrientations: ['portrait', 'landscape'],
        text: strings.timing_section_toast_error_start_end_time_text,
        position: 'bottom',
        buttonText:
          strings.timing_section_toast_error_start_end_time_ok_button_text,
      });
      return;
    }
    this.props.dispatch(setDuration(duration));
  };

  onTypePress = (value) => {
    return () => {
      if (this.props.typeOfPain === value) {
        this.props.dispatch(setPainType(null));
      } else {
        this.props.dispatch(setPainType(value));
      }
    };
  };
  onDurationChange = (value) => {
    let duration = value;
    if (isNaN(duration)) {
      this.setState({
        duration: this.formatDuration(
          this.props.duration,
          this.props.durationUnits,
        ),
      });
      return;
    }
    if (this.props.durationUnits === 'Minutes') {
      duration = duration * 60;
    } else if (this.props.durationUnits === 'Hours') {
      duration = duration * 60 * 60;
    }
    //        this.setState({duration: value.toString()});
    duration = parseFloat(duration);
    this.props.dispatch(setDuration(duration));
  };

  formatDuration = (seconds, durationUnits) => {
    let duration = seconds;
    if (durationUnits === 'Minutes') {
      duration = seconds / 60;
    } else if (durationUnits === 'Hours') {
      duration = seconds / 60 / 60;
    }

    //        duration = (Math.round(duration * 100) / 100.0);
    if (duration == 0 && seconds > 0) {
      return '0';
    }

    return duration
      ? durationUnits === 'Hours'
        ? (Math.round(duration * 100) / 100).toString()
        : duration.toFixed(0)
      : '';
  };

  onDurationTypePress = (value) => {
    return () => {
      let durationType = value === this.props.durationType ? null : value;
      this.props.dispatch(setDurationType(durationType));
      // if((value==='all_day' && !this.props.allDayChecked) || (value!=='all_day' && this.props.allDayChecked)) {
      //     this.onAllDayPress();
      // }
    };
  };
  onDurationUnitsChange = (value) => {
    this.props.dispatch(setDurationUnits(value));
  };

  onAllDayPress = () => {
    let checked = !this.props.allDayChecked;
    this.props.dispatch(setAllDayChecked(checked));
  };

  render() {
    const { typeOfPain, durationUnits } = this.props;

    var duration = this.props.duration;

    let dateTime =
      typeof this.props.recordTime !== 'undefined'
        ? Moment(this.props.recordTime)
        : Moment();
    const endTime = dateTime.clone();
    endTime.add(duration, 'seconds');

    //        console.log('RENDER DURATION???', this.state.duration, this.state.duration.toString());
    return (
      <View style={styles.container}>
        <View style={{ flexDirection: 'row' }}>
          <FloatingInput
            datePicker
            grayBackground
            label={strings.timing_section_start_date}
            style={{ flex: 1, marginRight: 4 }}
            value={dateTime}
            datePickerMode={'date'}
            webDateTime={this.props.durationType !== 'all_day'}
            openTo={'day'}
            onDateChange={this.onStartDateChanged}
          />
          {this.props.durationType !== 'all_day' ? (
            <FloatingInput
              datePicker
              grayBackground
              label={strings.timing_section_start_time}
              style={{ flex: 1, marginLeft: 4 }}
              value={dateTime}
              datePickerMode={'time'}
              webDateTime={true}
              openTo={'hours'}
              onDateChange={this.onStartDateChanged}
            />
          ) : (
            <View style={{ flex: 1 }} />
          )}
        </View>
        <Text note style={{ marginVertical: 8 }}>
          {strings.timing_section_type_header}
        </Text>
        <SquareCheckButton
          checkbox
          checked={typeOfPain === 'Constant'}
          onPress={this.onTypePress('Constant')}
          label={strings.timing_section_type_constant}
        />
        <SquareCheckButton
          checkbox
          checked={typeOfPain === 'Intermittent'}
          onPress={this.onTypePress('Intermittent')}
          label={strings.timing_section_type_intermittent}
        />
        <SquareCheckButton
          checkbox
          checked={typeOfPain === 'Breakthrough'}
          onPress={this.onTypePress('Breakthrough')}
          label={strings.timing_section_type_breakthrough}
        />
        <Text note style={{ marginTop: 20, marginBottom: 8 }}>
          {strings.timing_section_end_header}
        </Text>

        {/* If we have duration set, then show end date and time separately */}
        <SquareCheckButton
          checkbox
          checked={this.props.durationType === 'duration'}
          onPress={this.onDurationTypePress('duration')}
          label={strings.timing_section_duration_button}
        >
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              marginTop: 8,
              paddingHorizontal: 12,
            }}
          >
            <FloatingInput
              oldStyleInput
              keyboardType="numeric"
              style={{ flex: 1, marginRight: 4 }}
              grayBackground
              label={strings.timing_section_duration_label}
              value={this.state.duration ? this.state.duration.toString() : ''}
              onChangeText={(text) => this.onDurationChange(text)}
            />
            <FloatingInput
              oldStyleInput
              picker
              style={{ flex: 1, marginLeft: 4 }}
              grayBackground
              label={strings.timing_section_duration_units_label}
              value={
                strings['timing_section_duration_' + this.props.durationUnits]
              }
              pickerOnItemPress={(value) => {
                this.onDurationUnitsChange(value);
              }}
              pickerItems={[
                {
                  id: 'Seconds',
                  text: strings.timing_section_duration_Seconds,
                },
                {
                  id: 'Minutes',
                  text: strings.timing_section_duration_Minutes,
                },
                { id: 'Hours', text: strings.timing_section_duration_Hours },
              ]}
              pickerSelectedId={this.props.durationUnits}
            />
          </View>
        </SquareCheckButton>
        <SquareCheckButton
          checkbox
          checked={this.props.durationType === 'end_date'}
          onPress={this.onDurationTypePress('end_date')}
          label={strings.timing_section_end_date_button}
        >
          <View
            style={{
              flexDirection: 'row',
              marginTop: 8,
              paddingHorizontal: 12,
            }}
          >
            <FloatingInput
              oldStyleInput
              datePicker
              grayBackground
              label={strings.timing_section_end_date}
              style={{ flex: 1, marginRight: 4 }}
              value={endTime}
              datePickerMode="date"
              onDateChange={this.onEndDateChanged}
            />
            <FloatingInput
              oldStyleInput
              datePicker
              grayBackground
              label={strings.timing_section_end_time}
              style={{ flex: 1, marginLeft: 4 }}
              value={endTime}
              datePickerMode="time"
              onDateChange={this.onEndDateChanged}
            />
          </View>
        </SquareCheckButton>
        <SquareCheckButton
          checkbox
          checked={this.props.durationType === 'all_day'}
          onPress={this.onDurationTypePress('all_day')}
          label={strings.timing_section_all_day_button}
        />
      </View>
    );
  }
}

const FORMAT = 'DD-MM-YYYY HH:MM';

const styles = StyleSheet.create({
  container: {
    padding: designConstants.paddings.edgePadding,
  },
  subtitle: {
    fontWeight: 'bold',
  },
});

TimingSectionContent.defaultProps = {
  allDayChecked: false,
  startDate: '01-02-1991 00:01',
  painType: 'none',
};

const mapStateToProps = (state) => {
  return {
    allDayChecked:
      state.records.current.record &&
      state.records.current.record.allDayChecked,
    recordTime:
      state.records.current.record && state.records.current.record.recordTime,
    typeOfPain:
      state.records.current.record &&
      state.records.current.record.lengthOfPainType
        ? state.records.current.record.lengthOfPainType
        : null,
    duration:
      state.records.current.record &&
      state.records.current.record.lengthOfPainValue
        ? state.records.current.record.lengthOfPainValue
        : 0,
    durationType:
      state.records.current.record && state.records.current.record.durationType,
    durationUnits:
      state.records.current.record &&
      state.records.current.record.lengthOfPainUnit
        ? state.records.current.record.lengthOfPainUnit
        : 'Minutes',
  };
};

export default connect(mapStateToProps)(TimingSectionContent);
